export default "__VITE_ASSET__BOFgZ8Az__"